import React, { useState, useEffect } from "react";
import ChatBot from "react-simple-chatbot";
import { FaTimes } from "react-icons/fa";

import emailjs from '@emailjs/browser';
export default function ChatBotFile() {
  const [isChatbotOpen, setIsChatbotOpen] = useState(false);
  const [steps, setSteps] = useState([
    {
      id: "1",
      message: "Welcome to our service! How can I assist you today?",
      trigger: "options_info",
    },
    {
      id: "options_info",
      options: [
        {
          value: "GET_YOUR_FREE_QUOTE",
          label: "GET YOUR FREE QUOTE",
          trigger: "job_type_message"
        }
      ]
    },
    {
      id: "job_type_message",
      message: "What Type of Job?",

      trigger: "job_type",
    },
    {
      id: "job_type",
      user: true,
      trigger: "large_roof_message",
    },
    {
      id: "large_roof_message",
      message: "How large is the Roof ?",
      trigger: "large_roof",
    },
    {
      id: "large_roof",
      user: true,
      trigger: "structures_roof_message",
    },
    {
      id: "structures_roof_message",
      message: "Which structures will be on the roof?",
      trigger: "structures_roof",
    },
    {
      id: "structures_roof",
      user: true,
      trigger: "high_roof_message",
    },
    {
      id: "high_roof_message",
      message: "How high is the roof ?",
      trigger: "high_roof",
    },
    {
      id: "high_roof",
      user: true,
      trigger: "hiring_decission_message",
    },
    {
      id: "hiring_decission_message",
      message: "How likely are you to make a hiring decission?",
      trigger: "hiring_decission",
    },
    {
      id: "hiring_decission",
      user: true,
      trigger: "job_start_message",
    },
    {
      id: "job_start_message",
      message: "When would you like the job To start?",
      trigger: "job_start",
    },
    {
      id: "job_start",
      user: true,
      trigger: "authorised_message",
    },
    {
      id: "authorised_message",
      message: "Are you the owner or authorised to make property changes?",
      trigger: "authorised",
    },
    {
      id: "authorised",
      user: true,
      trigger: "first_name_message",
    },

    {
      id: "first_name_message",
      message: "Enter Your First Name",
      trigger: "first_name",
    },
    {
      id: "first_name",
      user: true,
      trigger: "last_name_message",
    },

    {
      id: "last_name_message",
      message: "Enter Your Last Name",
      trigger: "last_name",
    },
    {
      id: "last_name",
      user: true,
      trigger: "street_address_line_1_message",
    },

    {
      id: "street_address_line_1_message",
      message: "Enter Your street address line 1 ",
      trigger: "street_address_line_1",
    },
    {
      id: "street_address_line_1",
      user: true,
      trigger: "street_address_line_2_message",
    },
    {
      id: "street_address_line_2_message",
      message: "Enter Your street address line 2",
      trigger: "street_address_line_2",
    },
    {
      id: "street_address_line_2",
      user: true,
      trigger: "town_message",
    },
    {
      id: "town_message",
      message: "Enter Your Town Name",
      trigger: "town",
    },
    {
      id: "town",
      user: true,
      trigger: "postcode_message",
    },
    {
      id: "postcode_message",
      message: "Enter Your postcode",
      trigger: "postcode",
    },
    {
      id: "postcode",
      user: true,
      trigger: "phone_message",
    },
    {
      id: "phone_message",
      message: "Enter Your phone Number",
      trigger: "phone",
    },
    {
      id: "phone",
      user: true,
      trigger: "11",
    },
    {
      id: "email_message",
      message: "Enter Your email",
      trigger: "email",
    },
    {
      id: "email",
      user: true,
      trigger: "11",
    },
    {
      id: "11",
      message: "Thank you for your time and response. we will contact you soon.",
      end: true,
    },
  ]);
  const sendEmail = async (stepsData) => {
    const form = document.createElement('form'); // Create a new form element

    // Loop through the stepsData object and append each field as an input
    for (let key in stepsData) {
      const input = document.createElement('input');
      input.type = 'hidden';
      input.name = key;
      input.value = stepsData[key];
      form.appendChild(input);
    }


    await emailjs
      .sendForm('service_i0hcwx5', 'template_61qnmke', form, {
        publicKey: 'jkdGbFJGog4-bcnHG',
      })
      .then(
        () => {

          console.log('SUCCESS!');
        },
        (error) => {
          console.log('FAILED...', error);
        }
      );
  };
  const toggleChatbot = () => {
    setIsChatbotOpen(!isChatbotOpen);
  };

  const speakText = (text) => {
    const utterance = new SpeechSynthesisUtterance(text);
    window.speechSynthesis.speak(utterance);
  };

  const handleEnd = async (chatBotState) => {
    const { steps } = chatBotState;
    const lastStep = steps[steps.length - 1];
    if (steps && steps["job_type"]?.value) {
      let stepData = {
        job_type: steps["job_type"].value,
        large_roof: steps["large_roof"].value,
        structures_roof: steps["structures_roof"].value,
        high_roof: steps["high_roof"].value,
        hiring_decission: steps["hiring_decission"].value,
        job_start: steps["job_start"].value,
        authorised: steps["authorised"].value,
        first_name: steps["first_name"]?.value || "",
        last_name: steps["last_name"]?.value || "",
        street_address_line_1: steps["street_address_line_1"]?.value || "",
        street_address_line_2: steps["street_address_line_2"]?.value || "",
        town: steps["town"]?.value || "",
        postcode: steps["postcode"]?.value || "",
        phone: steps["phone"]?.value || "",
        email: steps["email"]?.value || ""
      }
      await sendEmail(stepData)
    }
    if (lastStep?.message && !lastStep.trigger) {
      speakText(lastStep.message);
    }
  };
  return (
    <div className="mainclass_of_chatbot">
      <button className="toggle-chatbot-button" onClick={toggleChatbot}>
        {isChatbotOpen ? (
          <img
            src="https://go4customer.com/images/blog/SIMPLE%20CHATBOTS.png"
            width="40px"
            height="40px"
            alt="Close Chatbot"
          />
        ) : (
          <img
            src="https://go4customer.com/images/blog/SIMPLE%20CHATBOTS.png"
            width="40px"
            height="40px"
            alt="Open Chatbot"
          />
        )}
      </button>

      <div className={`chat_boat_sub_div ${isChatbotOpen ? "open" : "close"}`}>
        <ChatBot
          steps={steps}
          key={JSON.stringify(steps)}
          handleEnd={(state) => handleEnd(state)}
          recognitionEnable={true}
          botAvatar="https://r2.erweima.ai/imgcompressed/compressed_b45d25e6806765b9fc2c9116ca599737.webp"
          headerComponent={
            <div className="d-flex justify-content-between m-2 align-items-center">
              <div className="fs-24 fw-600">Chat</div>
              <div>
                <FaTimes
                  onClick={() => {
                    setIsChatbotOpen(false);
                  }}
                  style={{ fontSize: "25px" }}
                  className="pointer mr-2"
                />
              </div>
            </div>
          }
        />


      </div>
    </div>
  );
}
